import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BGoogleSignIn',
  emits: ['login-success'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var config = useRuntimeConfig();
    var notifier = useNotifier();
    var scriptUrl = 'https://accounts.google.com/gsi/client';
    var scriptLoaded = false;
    function handleCredentialResponse(response) {
      emit('login-success', response);
    }
    function renderButton() {
      try {
        window.google.accounts.id.initialize({
          client_id: config.googleSSOClientId,
          callback: handleCredentialResponse,
          context: 'signin',
          ux_mode: 'popup',
          use_fedcm_for_prompt: true
        });
        window.google.accounts.id.renderButton(document.getElementById('google-button'), {
          theme: 'outline',
          text: 'signin_with',
          type: 'icon'
        });
        window.google.accounts.id.prompt(); // This will display the One Tap prompt
      } catch (error) {
        notifier.showMessage({
          content: "'Error rendering Google Sign-In button: ".concat(error, "'"),
          type: 'error'
        });
      }
    }
    function loadGoogleScript() {
      if (window.google && scriptLoaded) {
        // Script already loaded and initialized
        return;
      }
      var script = document.createElement('script');
      script.src = scriptUrl;
      script.async = true;
      script.defer = true;
      script.onload = function () {
        renderButton();
        scriptLoaded = true;
      };
      document.head.appendChild(script);
    }
    onMounted(function () {
      loadGoogleScript();
    });
    return {
      __sfc: true,
      emit: emit,
      config: config,
      notifier: notifier,
      scriptUrl: scriptUrl,
      scriptLoaded: scriptLoaded,
      handleCredentialResponse: handleCredentialResponse,
      renderButton: renderButton,
      loadGoogleScript: loadGoogleScript
    };
  }
});